const state = {
  userInfo: null ,// 初始化用户信息字段
  teacherInfo:null
};

const mutations = {
  // 更新用户信息的 mutation
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  SET_TEACHER_INFO(state, teacherInfo) {
    state.teacherInfo = teacherInfo;
  }
};

const actions = {
  // 触发更新用户信息的 action
  updateUserInfo({ commit }, userInfo) {
    commit('SET_USER_INFO', userInfo);
  },
  updateTeacherInfo({ commit }, teacherInfo) {
    commit('SET_TEACHER_INFO', teacherInfo);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};